import React from 'react';
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';

/**
 * Sortable table header cell.
 *
 * Props:
 *   col      — column key
 *   label    — displayed text
 *   sortBy   — currently active column key
 *   sortDir  — 'asc' | 'desc'
 *   onSort   — (col) => void
 */
export default function SortTh({ col, label, sortBy, sortDir, onSort, style }) {
  const active = sortBy === col;
  const icon = active
    ? (sortDir === 'asc' ? <FaSortUp /> : <FaSortDown />)
    : <FaSort />;

  return (
    <th
      className={`th-sortable${active ? ' th-sort-active' : ''}`}
      onClick={() => onSort(col)}
      style={style}
    >
      {label}
      <span className={`th-sort-icon${active ? ' active' : ''}`}>{icon}</span>
    </th>
  );
}
